import Banner from "../../organisms/Banner/Banner";
import Benefits from "../../organisms/Benefits/Benefits";
import ContactForm from "../../organisms/ContactForm/ContactForm";
import Pricing from "../../organisms/Pricing/Pricing";
import About from "../../organisms/About/About";
import Reviews from "../../organisms/Reviews/Reviews";
import { useEffect } from "react";

const HomePage = () => {
  useEffect(() => {
    // Function to handle scroll events
    const handleScroll = () => {
      // Get scroll position from either body or the homepage div
      const scrollTop =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.getElementById("dui-homepage")?.scrollTop ||
        0;

      // Set the data-scroll attribute on the documentElement
      document.documentElement.setAttribute(
        "data-scroll",
        scrollTop.toString()
      );
    };

    // Initialize scroll position to 0
    document.documentElement.setAttribute("data-scroll", "0");

    // Add event listeners to both window and homepage div
    window.addEventListener("scroll", handleScroll, { passive: true });

    const homepageDiv = document.getElementById("dui-homepage");
    if (homepageDiv) {
      homepageDiv.addEventListener("scroll", handleScroll, { passive: true });
    }

    // Initial call to set correct state
    handleScroll();

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (homepageDiv) {
        homepageDiv.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  return (
    <div className="dui-homepage" id="dui-homepage">
      <Banner />
      <About />
      <Benefits />
      <Pricing />
      <Reviews />
      <ContactForm />
    </div>
  );
};

export default HomePage;
